import ListInvalidDocumentFormComponent from "../../components/espace-document/ListInvalidDocumentFormComponent";
import useAppState from "../../context/AppContext";


export default function ListInvalidDocumentBloc() {
  const {
    state: { isConseiller }
  } = useAppState();

  return (
    <div className="">
      <div className="">
        <h2 className="card-title bleu mb-md">{isConseiller ? 'Justificatifs' :'Mes justificatifs'} </h2>
        <ListInvalidDocumentFormComponent />
      </div>
    </div>
  )
}